import { Indicator } from '../../../Common/Charts/Indicator';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const TradicionalGroupsIndicator = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <Indicator
            title={'Grupos Tradicionais'}
            indicatorValue={chartData?.indicators?.tradicionalGroups}
        />
    );
};
